import { toastService } from "cruzo";

export function showErrorToast(message: string, timeoutMs = 5000): void {
  toastService.show({
    kind: "error",
    message,
    alignX: "center",
    alignY: "top",
    timeoutMs,
  });
}
